// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2t6b4","inner":"Footer_inner__nj_wJ"};